"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Einbauart = void 0;
var Einbauart;
(function (Einbauart) {
    Einbauart["freitragend"] = "freitragend";
    Einbauart["gleitend"] = "gleitend";
    Einbauart["haengend"] = "haengend";
})(Einbauart = exports.Einbauart || (exports.Einbauart = {}));
//# sourceMappingURL=Einbauart.js.map